import AdminBookingOverviewComponent from "../components/admin/overview/admin.booking-overview.component";

const AdminOverviewPage = () => {
  return <AdminBookingOverviewComponent />;
};

export default AdminOverviewPage;